import React from "react";
const folderIcon = ({ styles, ...rest }) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42", ...rest }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    d: "M0 0H4823V3877H0z",
    transform: "translate(-1761 -3612)"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M1761 3612H1801V3654H1761z", transform: "translate(-1761 -3612)" }), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M.716 29.29V1.726c0-.552.448-1 1-1h.003l13.104.039c.307 0 .597.143.786.385l3.812 4.888c.189.243.48.385.788.385h16.072c.552 0 1 .447 1 1V29.29h0H.716z",
    transform: "translate(-1761 -3612) translate(1762 3619)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M0.656 6.431L20.482 6.431",
    transform: "translate(-1761 -3612) translate(1762 3619)"
  }
))));
var folderIcon_default = folderIcon;
export {
  folderIcon_default as default
};
//# sourceMappingURL=folderIcon.js.map
